<template>
  <div v-if="raffleID" class="raffle-card">
    <Loader v-if="loading" :loading="loading" :absolute="true" />
    <v-layout wrap class="mb-4">
      <v-flex sm12 xs12 md5 lg3>
        <v-btn
          color="success"
          class="p-0 mb-5"
          v-bind:disabled="loading"
          @click="updateItem"
          text
        >Сохранить</v-btn>

        <div class="body-2">
          Наименование
          <b class="text-success">[ {{language}} ]</b>
        </div>

        <v-text-field v-model="title"></v-text-field>

        <v-checkbox class="mt-4" v-model="is_active" label="Виден"></v-checkbox>

        <v-checkbox class="mt-1" v-model="is_universal" label="Акция на все товары"></v-checkbox>

        <v-checkbox class="mt-1" v-model="is_information" label="Только информация"></v-checkbox>

        <br />

        <div class="body-2 mb-3 mt-2">Производитель</div>

        <multiselect
          v-model="vendor"
          tag-placeholder="Выберете или напишите новый"
          selectedLabel="Применен"
          placeholder="Бренд"
          :showLabels="false"
          label="title"
          track-by="id"
          :options="brandSelect"
          :taggable="false"
          :multiple="false"
        ></multiselect>

        <div class="body-2 mb-3 mt-2">Определенные товары (акртикулы)</div>

        <multiselect
          v-model="participant"
          tag-placeholder="Выберете или напишите новый"
          selectedLabel="Применен"
          placeholder="Вставьте артикулы"
          :showLabels="false"
          label="vendor_code"
          track-by="id"
          :loading="findLoading"
          :options="vendor_codes"
          :taggable="false"
          :multiple="true"
          @search-change="asyncFind"
        ></multiselect>

        <div class="body-2 mb-2 mt-4">
          Изображение првью (800x450 px)
          <b class="text-success">[ {{language}} ]</b>

          <div
            v-if="image_previewBASE64"
            @click="image_previewBASE64=null"
            class="right user-link"
          >Отменить</div>
        </div>

        <v-checkbox class="mt-3" v-model="image_preview_remove" label="Удалить изображение"></v-checkbox>

        <div class="fileValuePreview mb-4" @click="$refs.fileValuePreview.click()">
          <input
            type="file"
            ref="fileValuePreview"
            @change="uploadValuePreviewBASE64"
            accept="image/x-png, image/jpeg, image/jpg"
            class="choose-file"
          />

          <div class="image-shadow"></div>

          <img v-if="image_previewBASE64" class="image_into BASE64" :src="image_previewBASE64" />

          <img v-if="image_preview" class="image_into" :src="image_preview" />

          <small class="label-image">Нажмите, чтобы выбрать изображение</small>
        </div>

        <br />

        <div class="body-2 mb-2">
          Изобржение шапка (1920x350)
          <b class="text-success">[ {{language}} ]</b>

          <div
            v-if="image_presentBASE64"
            @click="image_presentBASE64=null"
            class="right user-link"
          >Отменить</div>
        </div>

        <v-checkbox class="mt-1" v-model="image_present_remove" label="Удалить изображение"></v-checkbox>

        <div class="fileValuePresent" @click="$refs.fileValuePresent.click()">
          <input
            type="file"
            ref="fileValuePresent"
            @change="uploadValuePresentBASE64"
            accept="image/x-png, image/jpeg, image/jpg"
            class="choose-file"
          />

          <div class="image-shadow"></div>

          <img v-if="image_presentBASE64" class="image_into BASE64" :src="image_presentBASE64" />

          <img v-if="image_present" class="image_into" :src="image_present" />

          <small class="label-image">Нажмите, чтобы выбрать изображение</small>
        </div>

        <br />

        <br />

        <div class="body-2">Приоритет - чем больше число, тем выше акция</div>
        <v-text-field class="mb-5" v-model="position"></v-text-field>

        <v-btn color="success" v-bind:disabled="loading" @click="updateItem" text>Сохранить</v-btn>
        <br />
      </v-flex>

      <v-flex sm12 xs12 md1 lg1></v-flex>

      <v-flex sm12 xs12 md6 lg8>
        <div>
          <div class="body-2">Дата окончания - время по умолчанию 00:00:00</div>
          <br />
          <v-date-picker
            :dark="true"
            v-model="picker"
            :landscape="false"
            locale="ru"
            :color="'primary'"
            :reactive="true"
            :full-width="true"
            :show-current="true"
            :multiple="false"
            :readonly="false"
            :disabled="false"
          ></v-date-picker>
          <br />

          <div class="body-2 mt-2 mb-3">
            Контент
            <b class="text-success">[ {{language}} ]</b>
          </div>

          <vue-editor
            class="mb-4"
            v-model="body"
            placeholder="Напишите текст..."
            :editor-toolbar="customToolbar"
            :customModules="customModulesForEditor"
          ></vue-editor>

          <v-btn color="success" v-bind:disabled="loading" @click="updateItem" text>Сохранить</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { VueEditor } from "vue2-editor";
import Loader from "../../helper/Loader";

export default {
  components: { Loader, VueEditor },
  data() {
    return {
      image_present: "",
      image_preview: "",
      loading: true,
      findLoading: false,

      vendor_codes: [],

      participant: [],
      raffle: null,
      picker: null,
      vendor: null,
      body: null,
      title: null,
      is_active: false,
      is_universal: false,
      is_information: false,

      image_preview_remove: false,

      image_present_remove: false,

      position: 0,
      image_previewBASE64: null,
      image_presentBASE64: null,

      customToolbar: [
        // ["bold", "italic", "underline"],
        // [{list: "ordered"}, {list: "bullet"}],
        // ["image", "video"]
      ],
      customModulesForEditor: []
    };
  },
  props: ["raffleID", "closeRaffle"],
  methods: {
    close() {
      this.$dialog
        .confirm("Закрыть карточку?", {
          okText: "Да",
          cancelText: "Отмена"
        })
        .then(() => {
          this.closeRaffle(true);
        })
        .catch(() => {});
    },
    updateItem() {
      this.loading = true;
      axios
        .post("admin/raffles/set", {
          raffle_id: this.raffle_id,

          vendor: this.vendor,

          title: this.title,

          image_preview_remove: this.image_preview_remove,

          image_present_remove: this.image_present_remove,

          body: this.body,

          is_universal: this.is_universal,

          is_active: this.is_active,

          is_information: this.is_information,

          position: this.position,

          before_at: this.picker + " 00:00:00",

          image_previewBASE64: this.image_previewBASE64,

          image_presentBASE64: this.image_presentBASE64,

          participant: this.participant
        })
        .then(response => {
          if (response.data) {
            if (response.data.image_present) {
              this.image_present = response.data.image_present_medium;
            }

            if (response.data.image_preview) {
              this.image_preview = response.data.image_preview_medium;
            }

            this.image_previewBASE64 = this.image_presentBASE64 = null;
          }

          if (this.image_preview_remove === true) {
            this.image_preview = null;
            this.image_preview_remove = false;
          }

          if (this.image_present_remove === true) {
            this.image_present = null;
            this.image_present_remove = false;
          }

          this.$toast.success({
            title: "Изменение параметров",
            message: "Вы успешно обновили акцию"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    asyncFind(query) {
      this.findLoading = true;
      axios
        .get("admin/products/search", {
          params: {
            search: query
          }
        })
        .then(response => {
          this.vendor_codes = response.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.findLoading = false;
          }, 400);
        });
    },

    getRaffle() {
      axios
        .get("admin/raffles/card/" + this.raffle_id)
        .then(response => {
          this.raffle = response.data;

          if (this.raffle && this.raffle.before_at) {
            this.picker = this.raffle.before_at.split(" ")[0];
          }

          this.vendor = this.raffle.vendor;
          this.title = this.raffle.title;
          this.body = this.raffle.body;
          this.is_universal = this.raffle.is_universal;
          this.is_active = this.raffle.is_active;
          this.is_information = this.raffle.is_information;
          this.image_preview = this.raffle.image_preview_medium;
          this.image_present = this.raffle.image_present_medium;
          this.position = this.raffle.position;
          this.participant = this.raffle.participant;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    },

    async uploadValuePreviewBASE64() {
      let new_images = this.$refs.fileValuePreview.files;

      const reader = new FileReader();
      if (
        new_images &&
        new_images.length &&
        new_images[0] &&
        new_images[0].size < 1048576
      ) {
        reader.readAsDataURL(new_images[0]);
        await reader.addEventListener("load", () => {
          this.image_previewBASE64 = reader.result;
        });
      } else {
        this.$toast.error({
          title: "Изображение",
          message: "Размер изображения не должен быть более 1 мб"
        });

        this.image_previewBASE64 = null;
      }
    },

    async uploadValuePresentBASE64() {
      let new_images = this.$refs.fileValuePresent.files;

      const reader = new FileReader();
      if (
        new_images &&
        new_images.length &&
        new_images[0] &&
        new_images[0].size < 1048576
      ) {
        reader.readAsDataURL(new_images[0]);
        await reader.addEventListener("load", () => {
          this.image_presentBASE64 = reader.result;
        });
      } else {
        this.$toast.error({
          title: "Изображение",
          message: "Размер изображения не должен быть более 1 мб"
        });
        this.image_presentBASE64 = null;
      }
    }
  },
  computed: {
    ...mapState(["brands", "language"]),

    brandSelect: {
      get() {
        return this.brands;
      }
    },
    raffle_id: {
      get() {
        return this.raffleID;
      },
      set(val) {
        // this.currentOrder = val;
      }
    }
  },
  created() {
    this.getRaffle();
    console.log(this.raffleID);
  },
  watch: {
    language(val) {
      if (val) {
        this.loading = true;
        this.getRaffle();
      }
    }
  }
};
</script>

<style lang="scss">
.raffle-card {
  .text-white {
    color: #ffffff !important;
    font-weight: 500;
  }

  .fileValuePreview,
  .fileValuePresent {
    background: #777;
    height: 0;
    width: 100%;
    overflow: hidden;
    position: relative;
    border-radius: 3px;
    cursor: pointer;
  }

  .fileValuePreview {
    padding-top: 56% !important;
  }

  .fileValuePresent {
    padding-top: 18.2% !important;
  }

  .label-image {
    color: #fff;
    position: absolute;
    bottom: 5px;
    left: 10px;
    z-index: 2;
  }

  .image-shadow {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    transition: 0.4s;
  }

  .image-shadow:hover {
    background: transparent;
  }

  .image_into {
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  .image_into.BASE64 {
    z-index: 1;
  }
}
</style>
